// MainContent.jsx
import React from "react";
import GeneralRentersGuide from "./GeneralRentersGuide";
import GeneralEVTips from "./GeneralEVTips";
import ChevyBolt from "./Cars/2019ChevyBolt";
import TeslaModel3 from "./Cars/2019TeslaModel3";
import ToyotaSienna from "./Cars/2022ToyotaSienna";
import TeslaModelY from "./Cars/2021TeslaModelY";

export default function MainContent({
  activeMainTab,
  activeCar,
  activeCarSubTab,
  handleCarSubTabClick,
  matchesSearch,
  carTabs,
}) {
  // find the label for the active car
  const activeCarLabel =
    activeCar && carTabs.find((c) => c.id === activeCar)?.label;

  return (
    <div className="max-w-7xl mx-auto px-6 space-y-10">
      {activeMainTab === "generalEV" && (
        <GeneralEVTips matchesSearch={matchesSearch} activeSubTab={activeCarSubTab}
          handleSubTabClick={(carId, subId) =>
            handleCarSubTabClick("bolt", subId)
          } />
      )}

      {activeMainTab === "cars" && activeCar === "bolt" && (
        <ChevyBolt
          activeSubTab={activeCarSubTab}
          handleSubTabClick={(carId, subId) =>
            handleCarSubTabClick("bolt", subId)
          }
          carLabel={activeCarLabel}
        />
      )}

      {activeMainTab === "cars" && activeCar === "tesla" && (
        <TeslaModel3
          activeSubTab={activeCarSubTab}
          handleSubTabClick={(carId, subId) =>
            handleCarSubTabClick("tesla", subId)
          }
          carLabel={activeCarLabel}
        />
      )}

      {activeMainTab === "cars" && activeCar === "sienna" && (
        <ToyotaSienna
          activeSubTab={activeCarSubTab}
          handleSubTabClick={(carId, subId) =>
            handleCarSubTabClick("sienna", subId)
          }
          carLabel={activeCarLabel}
        />
      )}

      {activeMainTab === "cars" && activeCar === "modelY" && (
        <TeslaModelY
          activeSubTab={activeCarSubTab}
          handleSubTabClick={(carId, subId) =>
            handleCarSubTabClick("modelY", subId)
          }
          carLabel={activeCarLabel}
        />
      )}
    </div>
  );
}